module.exports = __webpack_public_path__ + "static/media/cel.a9d9efcb.png";